export default __webpack_public_path__ + "static/media/low_occupancy.d14bbffa.png";